import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';

// components
import {
    check,
    paypal,
    affirm,
    creditCards,
    wireTransfer,
} from './PdpSharedPaymentCards/PdpSharedPaymentCards';

// helpers
import { showPaypal } from '../helpers/paypal';
import { showAffirm } from '../helpers/affirm';

function PdpSharedDetailPayments({ viewer, item, user, currency }) {
    return (
        <span data-tn="pdp-spec-payment-methods">
            <FormattedMessage
                id="pdpDetails.paymentsPolicy"
                defaultMessage="1stdibs accepts the following payment methods"
            />
            <div>
                {/* Visa / Discover / American Express / Master Card */}
                {creditCards}
                {/* Paypal */}
                {showPaypal({ item, user }) && paypal}
                {/* Wire Transfer */}
                {!!(user && (user.isVip || user.isVerifiedTrade)) && wireTransfer}
                {/* Check */}
                {!!(user && user.canCheckoutWithCheck) && check}
                {/* Affirm */}
                {showAffirm({ viewer, item, user, currency }) && affirm}
            </div>
        </span>
    );
}

PdpSharedDetailPayments.propTypes = {
    currency: PropTypes.string,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailPayments, {
    viewer: graphql`
        fragment PdpSharedDetailPayments_viewer on Viewer {
            affirmEnabled: isEnabled(key: "affirmCheckout")
            regionalInfo {
                countryCode
            }
        }
    `,
    user: graphql`
        fragment PdpSharedDetailPayments_user on User {
            isVip
            isVerifiedTrade
            canSeeNetPrice: hasPermission(name: "B_NET_PRICE")
            canCheckoutWithCheck: hasPermission(name: "B_CHECKOUT_CHECK")
        }
    `,
    item: graphql`
        fragment PdpSharedDetailPayments_item on Item {
            pdpTypeDisplay
            affirmDisplayInfo: displayInfo {
                showAffirmPromo
            }
            pricing {
                prices {
                    type
                    status
                    amount {
                        convertedAmounts {
                            USD
                        }
                    }
                }
            }
        }
    `,
});
